import { render, staticRenderFns } from "./session-expiry-modal.vue?vue&type=template&id=517541b2"
import script from "./session-expiry-modal.vue?vue&type=script&lang=js"
export * from "./session-expiry-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports